import { CommonActionTypes } from './common.types';

const setLoading = loading => ({
  type: CommonActionTypes.SET_LOADING,
  payload: {
    loading,
  },
});

const setNotifications = notifications => ({
  type: CommonActionTypes.SET_NOTIFICATIONS,
  payload: notifications,
});

const clearNotification = index => ({
  type: CommonActionTypes.CLEAR_NOTIFICATIONS,
  payload: { index },
});

const clearAllNotifications = () => ({
  type: CommonActionTypes.CLEAR_ALL_NOTIFICATIONS,
});

const setRedirect = redirect => ({
  type: CommonActionTypes.SET_REDIRECT,
  payload: {
    redirect,
  },
});

const clearRedirect = () => ({
  type: CommonActionTypes.CLEAR_REDIRECT,
});

const setServerTime = serverTime => ({
  type: CommonActionTypes.SET_SERVER_TIME,
  payload: {
    serverTime,
  },
});

const requestServerTime = () => ({
  type: CommonActionTypes.REQUEST_SERVER_TIME,
});

const setServerTimeLoading = serverTimeLoading => ({
  type: CommonActionTypes.SET_SERVER_TIME_LOADING,
  payload: {
    serverTimeLoading,
  },
});

const setToggles = toggles => ({
  type: CommonActionTypes.SET_TOGGLES,
  payload: toggles,
});

const setShouldRenderAiGuide = bool => ({
  type: CommonActionTypes.SET_SHOULD_RENDER_AI_GUIDE,
  payload: bool,
});

const requestPdfUrlByType = ({ pdfUrl, urlType, fallBackAction }) => ({
  type: CommonActionTypes.REQUEST_PDF_URL_BY_TYPE,
  payload: {
    pdfUrl,
    urlType,
    fallBackAction,
  },
});

const setPdfUrl = url => ({
  type: CommonActionTypes.SET_PDF_URL,
  payload: {
    url,
  },
});

const aiChatGetPrompts = ({ promptId }) => ({
  type: CommonActionTypes.GET_PROMPT_FROM_ID,
  payload: {
    promptId,
  },
});

const actions = {
  loading: {
    set: setLoading,
  },
  notifications: {
    set: setNotifications,
    remove: clearNotification,
    clearAll: clearAllNotifications,
  },
  redirect: {
    set: setRedirect,
    clear: clearRedirect,
  },
  serverTime: {
    set: setServerTime,
    request: requestServerTime,
    setLoading: setServerTimeLoading,
  },
  toggles: {
    set: setToggles,
  },
  pdf: {
    request: requestPdfUrlByType,
    set: setPdfUrl,
  },
  setShouldRenderAiGuide,
  aiChatGetPrompts,
};

export default actions;
